import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, className, id, ...rest },
  ref
) {
  const generated = useId();
  const cbId = id ?? generated;
  return (
    <label
      htmlFor={cbId}
      className={cn('group inline-flex cursor-pointer items-center gap-3 select-none', className)}
    >
      <span className="relative inline-flex h-5 w-5 items-center justify-center">
        <input
          ref={ref}
          id={cbId}
          type="checkbox"
          className="peer absolute inset-0 h-full w-full cursor-pointer appearance-none rounded border border-white/20 bg-white/5 transition-colors checked:border-[color:var(--color-brand-magenta)] checked:bg-[color:var(--color-brand-magenta)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--color-brand-magenta)]"
          {...rest}
        />
        <svg
          className="pointer-events-none relative h-3 w-3 text-white opacity-0 transition-opacity duration-150 peer-checked:opacity-100"
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5"
          strokeLinecap="round" strokeLinejoin="round" aria-hidden
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </span>
      {label && (
        <span className="text-[14px] text-[color:var(--color-text-secondary)] transition-colors group-hover:text-white">
          {label}
        </span>
      )}
    </label>
  );
});
